import axios from '../axios'
// responseType: 'blob'
//文档导出基础档
//导出仓库信息
export const doBaseStockExport = (data) => {
  return axios({
    url: '/api/sys/export/base/doBaseStockExport',
    method: 'post',
    data
  })
}
//导出往来单位信息
export const doBasePartnerExport = (data) => {
  return axios({
    url: '/api/sys/export/base/doBasePartnerExport',
    method: 'post',
    data
  })
}
//导出物料信息
export const exportBaseMaterial = (data) => {
  return axios({
    url: '/api/sys/export/base/exportBaseMaterial',
    method: 'post',
    data
  })
}
//导出单位自有车辆信息
export const doBasePartnerCarExport = (data) => {
  return axios({
    url: '/api/sys/export/base/doBasePartnerCarExport',
    method: 'post',
    data
  })
}
//导出小车车辆信息
export const doBaseCarExport = (data) => {
  return axios({
    url: '/api/sys/export/base/doBaseCarExport',
    method: 'post',
    data
  })
}
//导出车辆进出信息
export const doBaseCarLogExport = (data) => {
  return axios({
    url: '/api/sys/export/base/doBaseCarLogExport',
    method: 'post',
    data
  })
}

//文档导出通用单据
//销售订单导出(按单导出)
export const salSalOrderExport = (data) => {
  return axios({
    url: '/api/sys/sal/salOrderExport',
    method: 'post',
    data
  })
}
//导出其他入库单据
export const doStkInOtherExport = (data) => {
  return axios({
    url: '/api/sys/export/bill/doStkInOtherExport',
    method: 'post',
    data
  })
}
//导出调拨单据
export const doStkMoveExport = (data) => {
  return axios({
    url: '/api/sys/export/bill/doStkMoveExport',
    method: 'post',
    data
  })
}
//导出材料出库单据
export const doStkOutMaterialExport = (data) => {
  return axios({
    url: '/api/sys/export/bill/doStkOutMaterialExport',
    method: 'post',
    data
  })
}
//导出材料退库单据
export const doStkOutMaterialReturnExport = (data) => {
  return axios({
    url: '/api/sys/export/bill/doStkOutMaterialReturnExport',
    method: 'post',
    data
  })
}
//导出其他出库单据
export const doStkOutOtherExport = (data) => {
  return axios({
    url: '/api/sys/export/bill/doStkOutOtherExport',
    method: 'post',
    data
  })
}
//导出销售出库单据
export const doStkOutSaleBillExport = (data) => {
  return axios({
    url: '/api/sys/export/bill/doStkOutSaleBillExport',
    method: 'post',
    data
  })
}
//导出采购订单单据
export const exportPurOrderBill = (data) => {
  return axios({
    url: '/api/sys/export/bill/exportPurOrderBill',
    method: 'post',
    data
  })
}
//导出采购入库单据
export const exportStkInPurchaseBill = (data) => {
  return axios({
    url: '/api/sys/export/bill/exportStkInPurchaseBill',
    method: 'post',
    data
  })
}
//导出产成品入库单据
export const exportStkInProductBill = (data) => {
  return axios({
    url: '/api/sys/export/bill/exportStkInProductBill',
    method: 'post',
    data
  })
}
//导出产成品退货单据
export const exportStkInProductReturnBill = (data) => {
  return axios({
    url: '/api/sys/export/bill/exportStkInProductReturnBill',
    method: 'post',
    data
  })
}

//文档导出excel
//过磅信息导出
export const listWeighExport = (data) => {
  return axios({
    url: '/api/sys/export/listWeighExport',
    method: 'post',
    data
  })
}

//送货单导出
export const purArrivalExport = (data) => {
  return axios({
    url: '/api/sys/export/purArrivalExport',
    method: 'post',
    data
  })
}

//采购订单导出
export const purOrderExport = (data) => {
  return axios({
    url: '/api/sys/export/purOrderExport',
    method: 'post',
    data
  })
}

//销售日报导出
export const salDailyReportExport = (data) => {
  return axios({
    url: '/api/sys/export/salDailyReportExport',
    method: 'post',
    data
  })
}

//销售月报导出
export const salMonthlyReportExport = (data) => {
  return axios({
    url: '/api/sys/export/salMonthlyReportExport',
    method: 'post',
    data
  })
}

//销售订单统计表导出
export const salOrderExport = (data) => {
  return axios({
    url: '/api/sys/export/salOrderExport',
    method: 'post',
    data
  })
}

//销售占比表导出
export const salProportionReportExport = (data) => {
  return axios({
    url: '/api/sys/export/salProportionReportExport',
    method: 'post',
    data
  })
}

//采购日报导出
export const stkInPurchaseDailyReportExport = (data) => {
  return axios({
    url: '/api/sys/export/stkInPurchaseDailyReportExport',
    method: 'post',
    data
  })
}


//采购月报导出
export const stkInPurchaseMonthlyReportExport = (data) => {
  return axios({
    url: '/api/sys/export/stkInPurchaseMonthlyReportExport',
    method: 'post',
    data
  })
}

//采购入库单导出
export const stkInPurchaseReportExport = (data) => {
  return axios({
    url: '/api/sys/export/stkInPurchaseReportExport',
    method: 'post',
    data
  })
}

//采购入库单明细导出
export const stkInPurchaseReportDetailsExport = (data) => {
  return axios({
    url: '/api/sys/export/stkInPurchaseReportDetailsExport',
    method: 'post',
    data
  })
}

//采购单统计表导出
export const stkInPurchaseReportPageExport = (data) => {
  return axios({
    url: '/api/sys/export/stkInPurchaseReportPageExport',
    method: 'post',
    data
  })
}

//销货单统计表导出
export const stkOutSaleReportExport = (data) => {
  return axios({
    url: '/api/sys/export/stkOutSaleReportExport',
    method: 'post',
    data
  })
}

//客户充值统计报表导出
export const tuRechargeReportExport = (data) => {
  return axios({
    url: '/api/sys/export/tuRechargeReportExport',
    method: 'post',
    data
  })
}

//销售出库单统计表导出
export const stkOutSaleByConditionExport = (data) => {
  return axios({
    url: '/api/sys/export/stkOutSaleByConditionExport',
    method: 'post',
    data
  })
}

//其他入库单明细导出
export const stkInOtherDetailsExport = (data) => {
  return axios({
    url: '/api/sys/export/stkInOtherDetailsExport',
    method: 'post',
    data
  })
}

//其他入库单统计表导出
export const stkInOtherReportByConditionExport = (data) => {
  return axios({
    url: '/api/sys/export/stkInOtherReportByConditionExport',
    method: 'post',
    data
  })
}

//产成品入库单明细导出
export const stkInProductDetailsExport = (data) => {
  return axios({
    url: '/api/sys/export/stkInProductDetailsExport',
    method: 'post',
    data
  })
}

//产成品入库统计表导出
export const stkInProductReportByConditionExport = (data) => {
  return axios({
    url: '/api/sys/export/stkInProductReportByConditionExport',
    method: 'post',
    data
  })
}

//销售出库单明细导出
export const stkOutSaleDetailsExport = (data) => {
  return axios({
    url: '/api/sys/export/stkOutSaleDetailsExport',
    method: 'post',
    data
  })
}

//材料出库单明细导出
export const stkOutMaterialDetailsExport = (data) => {
  return axios({
    url: '/api/sys/export/stkOutMaterialDetailsExport',
    method: 'post',
    data
  })
}

//材料出库单统计表导出
export const stkOutMaterialReportByConditionExport = (data) => {
  return axios({
    url: '/api/sys/export/stkOutMaterialReportByConditionExport',
    method: 'post',
    data
  })
}

//其他出库单明细导出
export const stkOutOtherDetailsExport = (data) => {
  return axios({
    url: '/api/sys/export/stkOutOtherDetailsExport',
    method: 'post',
    data
  })
}

//其他出库单统计表导出
export const stkOutOtherReportByConditionExport = (data) => {
  return axios({
    url: '/api/sys/export/stkOutOtherReportByConditionExport',
    method: 'post',
    data
  })
}


//客户月销售统计导出
export const doPartnerOrderInvoiceExport = (data) => {
  return axios({
    url: '/api/sys/fin/doPartnerOrderInvoiceExport',
    method: 'post',
    data
  })
}

//生效客户价格本导出
export const getPriceBookReportPage = (data) => {
  return axios({
    url: '/api/sys/export/getPriceBookReportPage',
    method: 'post',
    data
  })
}
//生效客户价格本导出
export const getPriceBookReportPageHsd = (data) => {
  return axios({
    url: '/api/sys/export/getPriceBookReportPageHsd',
    method: 'post',
    data
  })
}

//应收款导出
export const doAccountsReceivableListExport = (data) => {
  return axios({
    url: '/api/sys/fin/doAccountsReceivableListExport',
    method: 'post',
    data
  })
}
//应收款明细导出
export const doAccountsReceivableDetailListExport = (data) => {
  return axios({
    url: '/api/sys/fin/doAccountsReceivableDetailListExport',
    method: 'post',
    data
  })
}
//应付款导出
export const doAccountsPayableListExport = (data) => {
  return axios({
    url: '/api/sys/fin/doAccountsPayableListExport',
    method: 'post',
    data
  })
}
//应付款明细导出
export const doAccountsPayableDetailListExport = (data) => {
  return axios({
    url: '/api/sys/fin/doAccountsPayableDetailListExport',
    method: 'post',
    data
  })
}
//客户销售区域统计导出
export const doPartnerAreaSaleExport = (data) => {
  return axios({
    url: '/api/sys/export/doPartnerAreaSaleExport',
    method: 'post',
    data
  })
}
//【和顺德】本月称重列表导出
export const getSalOrderMonthExport = (data) => {
  return axios({
    url: '/api/sys/sal/getSalOrderMonthExport',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/excel.js